import React from "react";
import { HiOutlineHome } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneNeighborhood } from "../../../lib/sysNavigation/SysNavigation";

type NeighborhoodRow = {
  neighborhood_id: number | string;
  name?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<NeighborhoodRow>
    type={_TYPES_.NEIGHBORHOOD}
    title="Neighborhoods"
    subtitle="City neighborhoods listed on the public site."
    icon={<HiOutlineHome className="h-5 w-5" />}
    addRoute="/data/neighborhood/add"
    editRoute="/data/neighborhood/edit"
    pushOne={pushOneNeighborhood}
    dataKey="neighborhoods"
    countKey="neighborhoodsCount"
    idField="neighborhood_id"
    titleField="name"
    searchFields={["name"]}
  />
);

export default Overview;
